<template>
  <div>
    <organizer-detail-form
      v-if="organizer.details_confirmed === false"
      :organizer="organizer"
      :course-id="courseId"
      :is-partner-course="isPartnerCourse"
      :partner-id="partnerId"
      :phone-number-regex="phoneNumberRegex"
      @update-organizer="updateOrganizer"
    />
    <participants-details
      v-else
      :organizer="organizer"
      :course-price="coursePrice"
      :course-title="courseTitle"
      :course-id="courseId"
      :is-partner-course="isPartnerCourse"
      :partner-id="partnerId"
      :stripe-api-key="stripeApiKey"
      :stripe-account-id="stripeAccountId"
      :current-user-information="currentUserInformation"
    />
  </div>
</template>
<script>
import OrganizerDetailForm from "./OrganizerDetailForm.vue";
import ParticipantsDetails from "./ParticipantsDetails.vue";

export default {
  components: { OrganizerDetailForm, ParticipantsDetails },

  props: {
    currentUserInformation: { type: String, required: true },
    phoneNumberRegex: { type: String, required: true },
    courseTitle: { type: String, required: true },
    coursePrice: { type: Number, required: true },
    courseId: { type: Number, required: true },
    isPartnerCourse: { type: Boolean, required: true },
    partnerId: { type: Number, required: false, default: null },
    stripeApiKey: { type: String, required: true },
    stripeAccountId: { type: String, required: false, default: null },
  },

  data() {
    const parsedUserInformation = JSON.parse(this.currentUserInformation);

    return {
      organizer: {
        existing_account: parsedUserInformation.existing_account,
        first_name: parsedUserInformation.first_name,
        last_name: parsedUserInformation.last_name,
        mobile_number: parsedUserInformation.mobile_number,
        email: parsedUserInformation.email,
        enrolling_self: false,
        details_confirmed: false,
      },
    };
  },

  methods: {
    updateOrganizer(updatedOrganizer) {
      this.organizer = updatedOrganizer;
    },
  },
};
</script>
